<template>
  <div class="drugSearchComponent">
    <div class="flex drug_select_block">
      <div class="maxWidth">
        <v-select ref="select" v-model="drug" @keypress.enter.native.prevent="" label="title" :filterable="false"
                  @input="selectDrug"
                  :options="drugList"
                  @search="searchDrug">
          <template slot="no-options">
            введите название препарата..
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              <template v-if="option && option.title">
                {{ option.title }} ({{ option.id }})&nbsp;<b>[{{ option.main_store.qty }} уп.]</b>
              </template>
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <template v-if="option && option.title">
              {{ option.title }} ({{ option.id }})&nbsp;<b>[{{ option.main_store.qty }} уп.]</b>
            </template>
          </template>
        </v-select>
      </div>
      <div v-if="enableQty" class="flex">
        <div class="wd-70" v-if="drug">
          <input @change="updateDrug"
                v-model="drug.qty"
                 placeholder="Количество"
                 type="number"
                 class="form-control border-r-0  h-100"
                 name="qty"
          >
        </div>
      </div>
    </div>
  </div>

</template>

<script>

  import vSelect from 'vue-select';
  import VTooltip from 'v-tooltip'
  import api from '@/api'

  export default {
    components: {
      vSelect,
      VTooltip,
    },
    props: [
      'drugSelected', 'detailedSearch', 'enableQty', 'getPrice',
      'updateDrug', 'alreadySelectedCheck', 'onDrugSelect', 'url',
    ],
    data() {
      return {
        drugInfoLoading: false,
        localDrugData: null,
        drug: null,
        drugList: [],
      }
    },
    mounted() {
      if (this.drugSelected) {
        this.drug = this.drugSelected;
      }
    },
    methods: {
      selectDrug(e) {
        if (e) {
          e.qty = 1;
          if (this.alreadySelectedCheck){
            if (this.alreadySelectedCheck(e)){
              this.drug = null;
              toastr['warning']('Такой препарат уже выбран');
            }
          }
        }
        this.localDrugData = null;
        if (this.updateDrug){
          this.updateDrug();
        }
        if (this.onDrugSelect){
          this.onDrugSelect(this.drug);
        }
      },
      searchDrug(search, loading) {
        if (!search || search.length < 3) return;
        loading(true);
        this.search(loading, search, this);
      },
      search: _.debounce(async (loading, search, vm) => {
        const {data} = await api.index('/sms/segmentsDrugs?search=' + search);

        vm.drugList = [];
        vm.drugList = [...vm.drugList, ...data.items];
        loading(false);
      }, 1),
    }
  }

</script>

<style scoped>
  @media (max-width: 520px) {
    .drug_select_block {
      flex-direction: column;
    }
  }
  .drugSearchComponent{
    min-width: 250px;
  }
  .icon-info{
    text-align: center;
  }
  .sm-btn{
    height: 34px!important;
  }
  .v-select{
    font-size: 16px;
  }
  .wd-70 {
    width: 70px;
  }

  .maxWidth {
    width: 100%;
    /*min-width: 450px;*/
    /*width: 70%;*/
    text-align: left;
  }
</style>

<style>
  .vs--single .vs__selected{
    max-width: 100%;
  }
  .vs__dropdown-toggle{
    border-radius: 0;
    overflow: hidden;
    /*height: 35px;*/
  }
  .tooltip {
    //z-index: 99;
  }

  .tooltip-inner {
    background: white !important;
    color: #333 !important;
    max-width: max-content !important;
  }

  .drugSearchComponent .popover a {
    color: #007dcc;
  }

  .drugSearchComponent .popover {
    max-width: max-content !important;
  }
  .drugSearchComponent .vs__dropdown-toggle {
    height: auto !important;
    max-height: 117px;
    min-height: 38px;
    border-radius: 0;
  }

  .tooltip-inner p {
    text-align: left;
  }

  .tooltipBlock p {
    margin-bottom: 2px;
  }

</style>
